<template>
    <div class="view view--edit-tile">
        <edit-tile v-bind:id="id" />
    </div>
</template>

<script>
    import editTile from '../../components/EditTile.vue';

    export default {
        components: {
            editTile
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.tile) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/Edit.vue